<ng-container *transloco="let t">
  <div class="row" [formGroup]="editForm">
    <div class="col-6" formGroupName="config">
      <mat-form-field class="w-100" appearance="fill">
        <mat-label for="maxFiles">{{t('input-image-edit.maxFiles')}}</mat-label>
        <input matInput name="maxFiles" formControlName="maxFiles" type="number" />
      </mat-form-field>
    </div>
  </div>
</ng-container>
